import axios from '../../../axios';
import InvoiceExtra from '../types/InvoiceExtra';

export const url = '/invoicingservice/api/invoice-extra';

export const getAllInvoiceExtras = () => axios.get(url);
export const saveInvoiceExtra = (data: InvoiceExtra) => axios.post(url, data);
